import { INITIAL_RESET_RECORD_KEY, ROOT_RESET_RECORD_KEY } from '../constants';
export const flattenFormState = (obj, [k, v]) => {
    return {
        isValid: obj.isValid && v.isValid,
        isValidating: obj.isValidating || v.isValidating,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- WIP
        value: { ...obj.value, [k]: v.value },
    };
};
export const flattenFormObjectState = (state) => {
    return Object.entries(state).reduce(flattenFormState, {
        isValid: true,
        isValidating: false,
        value: {},
    });
};
export const flattenFormArrayState = (state) => {
    return Object.entries(state).reduce((obj, [, current]) => {
        return {
            isValid: obj.isValid && current.isValid,
            isValidating: obj.isValidating || current.isValidating,
            value: [...obj.value, current.value],
        };
    }, {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- widens the accumulator's literal type so reduce's overload resolves against the inline reducer's boolean return
        isValid: true,
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion -- widens the accumulator's literal type so reduce's overload resolves against the inline reducer's boolean return
        isValidating: false,
        value: [],
    });
};
export const shouldBeReset = ({ fieldId, resetFlag, }) => {
    return ((resetFlag.resetKey && fieldId.indexOf(resetFlag.resetKey) === 0) ||
        resetFlag.resetKey === ROOT_RESET_RECORD_KEY ||
        resetFlag.resetKey === INITIAL_RESET_RECORD_KEY ||
        resetFlag.resetList?.includes(fieldId));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Intentional
export const getNestedValue = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Intentional
item, path) => {
    if (path.length === 0 || !item) {
        return item;
    }
    else {
        const [currentProp, ...rest] = path;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Intentional
        return getNestedValue(item[currentProp], rest);
    }
};
export const composeValidators = function (...validators) {
    return async (value, dependencyValue) => {
        const validityCheck = {
            errors: [],
            isValid: true,
        };
        const validityChecks = await Promise.all(
        // eslint-disable-next-line @typescript-eslint/await-thenable -- a validator may return ValidityCheck | Promise<ValidityCheck>
        validators.map((validator) => validator(value, dependencyValue)));
        return validityChecks.reduce((accumulatedValidityCheck, currentValidityCheck) => {
            return {
                errors: [
                    ...accumulatedValidityCheck.errors,
                    ...currentValidityCheck.errors,
                ],
                isValid: accumulatedValidityCheck.isValid &&
                    currentValidityCheck.isValid,
            };
        }, validityCheck);
    };
};
